export default {
    title: "Add role",
    backToLink: {
        text: "Back to",
        section: "roles and users"
    },
    details: {
        title: "Detalji uloge",
        roleName: "Role name",
        placeholder: "Enter role name"
    },
    permissions: "Permissions",
    allPermissions: 'All permissions',
    users: {
        title: "Users",
        addUserButton: "Add users",
        emptyRole: "Currently there's no users in this role. You can add users later."
    },
    button: {
        cancel: "Cancel",
        addRole: "Add role",
    },
    showRole: {
        title: "Roles and Users",
        tabs: {
            roles: "Roles",
            users: "Users"
        },

        createRole: "Add Role",
        search: "Search roles",
        deleteRole: "Delete",

        table: {
            roleName: "Role name",
            personsNumber: "Persons number",
            permissions: "Permissions"
        }
    },
    roleOverview: {
        title: "Role Overview",
        editButton: "Edit",
        details: {
            title: "Role Details",
            roleTitle: "Role title"
        },
        permissions: {
            title: "Permissions"
        },

        buttons: {
            save: "Save",
            cancel: "Cancel"
        }
    },
    userTable: {
        title: "Users",
        username: "Username",
        email: "Email",
        roles: "Roles"
    },
}
